<template>
<div class="widthFull ">


  <div class="container mt-3  mt-md-5">
    <div class="row justify-content-center ">
      <!-- LOGIN -->
      <div v-if="!isAuthenticated" class="col-md-4 pl-md-0">
        <login />
      </div>
      <!-- RegBox -->
      <div v-if="!isAuthenticated" class="col-md-4  pt-3 mt-3">

        <div v-if="registration" class="form-row justify-content-center vaillantCont">

          <div class="col-md-12 mb-0 pb-0 text-center pr-0 pl-0">
            <img v-if="brand == 'CHEBONUS'" class="img-fluid widthFull" src="../../assets/images/regitem.png">
            <img v-if="brand == 'HAPPYBONUS'" class="img-fluid widthFull" src="../../assets/images/regitem.jpg">
          </div>
          <div class="col-md-12 mb-4 pb-3 text-center">

            <h4 v-if="brand == 'CHEBONUS'" class=" Regular text-left pb-0 pl-4 pr-4">Non sei ancora registrato a CheBonus?</h4>
            <h4 v-if="brand == 'HAPPYBONUS'" class=" Regular text-left pb-0 pl-4 pr-4">Non sei ancora registrato a HappyBonus?</h4>

            <p v-if="brand == 'CHEBONUS'"  class=" Regular text-left pb-4 pl-4 pr-4">
              L'accesso all'area riservata è soggetto all'approvazione di Vaillant ed il servizio è rivolto ai professionisti del settore
            </p>
            <p v-if="brand == 'HAPPYBONUS'"  class=" Regular text-left pb-4 pl-4 pr-4">
              L'accesso all'area riservata è soggetto all'approvazione di Hermann Saunier Duval ed il servizio è rivolto ai professionisti del settore
            </p>


            <router-link v-if="!isAuthenticated" class="btn btn-primary  mb-1" :class="{'btnHSDRed': brand == 'HAPPYBONUS' }" to="/registration">
              Registrati subito
            </router-link>
            </strong>

          </div>
        </div>

      </div>

      <div  v-if="isAuthenticated" class="col-md-4 pt-3 mt-3">
        <div class="form-row justify-content-center vaillantCont">

          <div class="col-md-12 mb-0 pb-0 text-center pr-0 pl-0">
            <img v-if="brand == 'CHEBONUS'" class="img-fluid widthFull" src="../../assets/images/area.jpg">
            <img v-if="brand == 'HAPPYBONUS'" class="img-fluid widthFull" src="../../assets/images/accountHSD.jpg">
          </div>
          <div class="col-md-12 mb-4 pb-3 text-center">

            <h4 class=" Regular text-left pb-0 pl-4 pr-4">Area riservata aderente</h4>

            <p class=" Regular text-left pl-4 pr-4">
              Benvenuto {{ getProfile.name }}
            </p>

            <p class=" Regular text-left pb-3 pl-4 pr-4 underline pointer">
              <router-link class="green mb-1" :class="{'redHSD': brand == 'HAPPYBONUS' }" to="/account">
                <b >Modifica profilo </b>
              </router-link>
            </p>

            <a @click="logout" class="btn btn-primary white mb-1" :class="{'btnHSDRed': brand == 'HAPPYBONUS' }" >
              Esci
            </a>
            </strong>

          </div>
        </div>
      </div>

      <div  v-if="isAuthenticated" class="col-md-4 pt-3 mt-3">
        <div class="form-row justify-content-center vaillantCont">

          <div class="col-md-12 mb-0 pb-0 text-center pr-0 pl-0">
            <img v-if=" brand == 'CHEBONUS' " class="img-fluid widthFull" src="../../assets/images/callcenter.jpg">
            <img v-if=" brand == 'HAPPYBONUS' "class="img-fluid widthFull" src="../../assets/images/callcenterHSD.jpg">
          </div>

          <div class="col-md-12 mb-4 pb-3 text-center">

            <h4 class=" Regular text-left pb-0 pl-4 pr-4">Servizio clienti</h4>

            <p class=" Regular text-left pb-0 pl-4 pr-4 ">
              Se hai bisogno di ulteriori informazioni

            </p>
            <div class="widthFull text-left pl-4 pr-4 pb-3">
            <router-link class="widthFull text-left mb-1" to="/contact">
              <img class="wa_icon mr-3" src="../../assets/images/wa.png">

              <font-awesome-icon icon="headset" class="green mr-3" :class="{'redHSD': brand == 'HAPPYBONUS' }"  size="2x" />
              <font-awesome-icon icon="envelope" class="green mr-3" :class="{'redHSD': brand == 'HAPPYBONUS' }"  size="2x" />

            </router-link>

            </div>

            <router-link class="btn btn-primary  mb-1" :class="{'btnHSDRed': brand == 'HAPPYBONUS' }" to="/contact">
              Contattaci qui
            </router-link>
            </strong>

          </div>
        </div>
      </div>
      <!-- MORE INFO => GO TO VAILLANT SITE -->
      <div class="col-md-4 pr-md-0 pt-3 mt-3">
        <div v-if="registration" class="form-row justify-content-center vaillantCont">

          <div class="col-md-12 mb-0 pb-0 text-center pr-0 pl-0">
            <img v-if="brand == 'CHEBONUS'" class="img-fluid widthFull" src="../../assets/images/more.jpg">
            <img v-if="brand == 'HAPPYBONUS'" class="img-fluid widthFull" src="../../assets/images/moreHSD.jpg">

          </div>
          <div class="col-md-12 mb-4 pb-3 text-center">

            <h4 v-if="brand == 'CHEBONUS'" class=" Regular text-left pb-0 pl-4 pr-4">Installa Vaillant e attiva CheBonus!</h4>
            <h4 v-if="brand == 'HAPPYBONUS'" class=" Regular text-left pb-0 pl-4 pr-4">Installa Hermann Saunier Duval e attiva HappyBonus</h4>

            <p v-if="brand == 'CHEBONUS'" class=" Regular text-left pb-3 pl-4 pr-4">
              Scopri i vantaggi unici di CheBonus, il servizio di Vaillant per fornire al tuo cliente lo sconto immediato in fattura.
            </p>
            <p v-if="brand == 'HAPPYBONUS'"  class=" Regular text-left pb-3 pl-4 pr-4">
              Scopri i vantaggi unici di HappyBonus, il servizio di Hermann Saunier Duval per fornire al tuo cliente lo sconto immediato in fattura.
            </p>

            <a v-if="brand == 'CHEBONUS'" href="https://www.vaillant.it/professionisti/prodotti/che-bonus/" target="_blank" class="btn btn-primary mb-1 mt-4" :class="{'btnHSDRed': brand == 'HAPPYBONUS' }"  >
              Scopri di più
            </a>
            <a v-if="brand == 'HAPPYBONUS'" href="https://www.hermann-saunierduval.it/per-il-professionista/happy-bonus/" target="_blank" class="btn btn-primary mb-1 mt-1" :class="{'btnHSDRed': brand == 'HAPPYBONUS' }"  >
              Scopri di più
            </a>


            </strong>

          </div>
        </div>
      </div>




    </div>

  </div>


</div>

</div>
</template>

<script>
import {
  mapGetters,
  mapState
} from 'vuex'
import {
  USER_REQUEST
} from 'actions/user'
import axios from 'axios'

import {
  AUTH_LOGOUT
} from 'actions/auth'

import login from './login.vue'

const moment = require('moment')

export default {
  components: {
    login
  },
  data() {
    return {
      moment: require('moment'),
      status: 'home',
      id: '',
      registration: process.env.REGISTRATION,
      brand: process.env.BRAND,
    }
  },
  name: 'areaRiservata',
  methods: {
    logout: function() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/login'))
    },

  },
  watch: {

    getProfile: function() {

    },

  },
  mounted: function() {
    this.$scrollTo('#app', 700, {
      offset: -775
    })
  },
  beforeUpdate: function() {

  },
  computed: {
    ...mapGetters(['isAuthenticated', 'authStatus', 'getProfile']),
    ...mapState({
      authLoading: state => state.auth.status === 'loading'
    }),
    loading: function() {
      return this.authStatus === 'loading' && !this.isAuthenticated
    }
  },
}
</script>

<style lang="css" scoped>

.vaillantCont {
  height: 100%;
}

.wa_icon{
  max-width: 40px;
  margin-top: -11px;
}

</style>



// WEBPACK FOOTER //
// src/components/areaRiservata/index.vue